import axios from './axios.service';

export const getOccupations = () => {
  return axios.get('/ocupation').then((res) => res.ocupations);
};

export const getSpecificOccupations = (occupationKey) => {
  return axios.get(`/ocupation/${occupationKey}`).then((res) => res.ocupations);
};
